import filesViewerReducer from '@components/common/filesPreview/common/redux/filesViewerSlice';
import treeReducer from '@components/common/tree/common/redux/treeSlice';
import administratorReducer from '@organisms/administrator/common/redux/administratorSlice';
import calendarReducer from '@organisms/calendar/common/redux/calendarSlice';
import rootOrdersReducer from '@organisms/orders/common/reducer';
import usersReducer from '@organisms/users/common/redux/usersSlice';
import workersRootReducer from '@organisms/workers/common/redux/reducer';
import cartReducer from '@pages/cart/store/cartSlice';
import workflowReducer from '@pages/orderWorkflow/store/workflowSlice';
import settingsReducer from '@pages/settingsCrm/contents/worksheetSetting/redux/settingsSlice';
import siteReducer from '@pages/site/store/siteSlice';
import { combineReducers } from '@reduxjs/toolkit';

import errorReducer from './Errors/errorSlice';
import loadingReducer from './Loadings/loadingSlice';

const rootReducer = combineReducers({
    orders: rootOrdersReducer,
    workers: workersRootReducer,
    loadings: loadingReducer,
    errors: errorReducer,
    filesViewer: filesViewerReducer,
    settings: settingsReducer,
    administrator: administratorReducer,
    users: usersReducer,
    tree: treeReducer,
    cart: cartReducer,
    workflow: workflowReducer,
    site: siteReducer,
    calendar: calendarReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
